import { render, staticRenderFns } from "./AwardPointPopup.vue?vue&type=template&id=b9869256"
import script from "./AwardPointPopup.vue?vue&type=script&lang=js"
export * from "./AwardPointPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports